<template>
  <section id="location" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">房源概况</div>
      </a-space>
    </div>

    <a-descriptions bordered class="desc-block">
      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">招租不动产名称</span>
        </template>
        {{ houseBaseInfo.housingResName }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">租赁面积（平方米）</span>
        </template>
        {{ houseBaseInfo.leaseArea }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">租赁期限</span>
        </template>
        {{ bidBaseInfo.leaseTerm }}{{ bidBaseInfo.leaseTermUnit }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">免租期（个月）</span>
        </template>
        {{
          bidBaseInfo.hasRentFreePeriod == 1
            ? "有：免租期时间" +
              (bidBaseInfo.rentFreePeriod || "") +
              (bidBaseInfo.rentFreePeriodUnit == 1
                ? "日"
                : bidBaseInfo.rentFreePeriodUnit == 2
                ? "个月"
                : "") +
              "；" +
              (bidBaseInfo.isRfpEtLr == 1
                ? "优先承租权人续租享有免租期"
                : "优先承租权人续租不享有免租期") +
              "；" +
              (bidBaseInfo.hasRentContainFreePeriod == 1
                ? "租赁期限包含免租期"
                : "租赁期限不包含免租期")
            : "无"
        }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">支付要求</span>
        </template>
        {{
          bidBaseInfo.rentPaymenclaim == 1
            ? "按月"
            : bidBaseInfo.rentPaymenclaim == 2
            ? "按季度"
            : bidBaseInfo.rentPaymenclaim == 3
            ? "按年"
            : bidBaseInfo.rentPaymenclaim == 4
            ? "其他：" + (bidBaseInfo.rentPaymenclaimDesc || "")
            : ""
        }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">物业管理费</span>
        </template>
        {{
          bidBaseInfo.hasPropertyManagementFee == 1
            ? "有物业管理费用，" +
              (bidBaseInfo.propertyManagementFeeWay == 1
                ? "由承租方直接与物业结算"
                : bidBaseInfo.propertyManagementFeeWay == 2
                ? "其他-" + (bidBaseInfo.propertyManagementFeeWayDesc || "")
                : "") +
              "，物业管理费用金额：" +
              (bidBaseInfo.propertyManagementFee || "") +
              (bidBaseInfo.propertyManagementFeeUnit == 1
                ? "元/天/平方米"
                : bidBaseInfo.propertyManagementFeeUnit == 2
                ? "元/月/平方米"
                : "")
            : "无物业管理费用"
        }}
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    bidBaseInfo: {
      type: Object,
      default: () => null,
    },
    houseBaseInfo: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}

.desc-block /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}
</style>